import moment from "moment";

export const DATE_INPUT_FMT = "YYYY-MM-DDTHH:mm";
export function makeEmptyCampaign(now = new Date()) {
    return {
        operatorReference: "",
        playerId: "",
        startTime: moment(now).format(DATE_INPUT_FMT),
        endTime: "",
        rounds: "",
        gameId: "",
        currency: "",
        amount: "",
        initialBalance: "",
        maxWin: "",
        slotConfigs: []
    };
}
export function addToEnd(campaign, { hours = 0, days = 0, weeks = 0 } = {}) {
    const base = campaign.startTime ? new Date(campaign.startTime) : new Date();
    if (hours) base.setHours(base.getHours() + hours);
    if (days) base.setDate(base.getDate() + days);
    if (weeks) base.setDate(base.getDate() + 7 * weeks);
    const pad = n => String(n).padStart(2, "0");
    const endTime = `${base.getFullYear()}-${pad(base.getMonth() + 1)}-${pad(base.getDate())}T${pad(base.getHours())}:${pad(base.getMinutes())}`;
    return { ...campaign, endTime };
}
export function sanitizeForCampaign(p) {
    const x = JSON.parse(JSON.stringify(p));
    x.playerList = null;
    if (Array.isArray(x.slotConfigs)) {
        x.slotConfigs = x.slotConfigs.map(cfg => ({
            ...cfg,
            game: cfg.game ? { gameId: cfg.game.gameId, gameName: cfg.game.gameName } : null
        }));
    }
    if (x.slotConfig?.games) x.slotConfig.games = x.slotConfig.games.map(({ gameId, gameName }) => ({ gameId, gameName }));
    if (x.liveConfig?.games) x.liveConfig.games = x.liveConfig.games.map(({ gameId, gameName }) => ({ gameId, gameName }));
    return x;
}
export const STATUS_KEY = {
    0: "DELETED",
    1: "ACTIVE",
    2: "COMPLETED",
    3: "EXPIRED",
    4: "SCHEDULED",
    5: "FINISHED"
};
export const STATUS_META = {
    ACTIVE: { label: "Activo", class: "bg-primary text-white" },
    SCHEDULED: { label: "Programado", class: "bg-warning text-dark" },
    FINISHED: { label: "Finalizado", class: "bg-dark text-white" },
    COMPLETED: { label: "Completado", class: "bg-success text-white" },
    EXPIRED: { label: "Expirado", class: "bg-danger text-white" },
    DELETED: { label: "Eliminado", class: "bg-secondary text-white" },
};
export function getStatusInfo(code) {
    const key = STATUS_KEY[Number(code) ?? 0];
    return STATUS_META[key] || { label: "Desconocido", class: "bg-secondary text-white" };
}

export function normalizeCampaignRow(doc) {
    const type = (doc?.campaignType || "").toUpperCase();
    const isSlot = type === "SLOT";
    const slotCfgs = Array.isArray(doc?.slotConfigs) ? doc.slotConfigs : null;
    const gamesArr = isSlot
        ? (slotCfgs ? slotCfgs.map(c => c.game).filter(Boolean) : (doc?.slotConfig?.games || []))
        : (doc?.liveConfig?.games || []);
    const gameLabel = gamesArr.length
        ? gamesArr.map(g => g.gameName || g.gameId).join(", ")
        : "—";
    const gameList = gamesArr.map(g => g.gameName || g.gameId).filter(Boolean);
    const amount = isSlot
        ? (slotCfgs ? slotCfgs.map(c => c.amountPerRound).filter(v => v != null).join(", ") : (doc?.slotConfig?.amountPerRound ?? "—"))
        : "—";
    const rounds = isSlot
        ? (slotCfgs ? slotCfgs.map(c => c.rounds).filter(v => v != null).join(", ") : (doc?.slotConfig?.rounds ?? "—"))
        : "—";
    const amountList = isSlot
        ? (slotCfgs ? slotCfgs.map(c => c.amountPerRound).filter(v => v != null) : (doc?.slotConfig?.amountPerRound != null ? [doc.slotConfig.amountPerRound] : []))
        : [];
    const roundsList = isSlot
        ? (slotCfgs ? slotCfgs.map(c => c.rounds).filter(v => v != null) : (doc?.slotConfig?.rounds != null ? [doc.slotConfig.rounds] : []))
        : [];
    const gameConfigs = isSlot
        ? (slotCfgs && slotCfgs.length
            ? slotCfgs.map(c => ({
                game: c.game?.gameName || c.game?.gameId || '—',
                amount: c.amountPerRound != null ? c.amountPerRound : '—',
                rounds: c.rounds != null ? c.rounds : '—'
            }))
            : (doc?.slotConfig?.games?.length
                ? doc.slotConfig.games.map(g => ({
                    game: g.gameName || g.gameId || '—',
                    amount: doc.slotConfig.amountPerRound ?? '—',
                    rounds: doc.slotConfig.rounds ?? '—'
                }))
                : (doc?.slotConfig?.amountPerRound != null || doc?.slotConfig?.rounds != null
                    ? [{ game: '—', amount: doc.slotConfig.amountPerRound ?? '—', rounds: doc.slotConfig.rounds ?? '—' }]
                    : [])))
        : (gamesArr.length ? gamesArr.map(g => ({ game: g.gameName || g.gameId || '—', amount: '—', rounds: '—' })) : []);
    const startMs = doc?.startDate ? new Date(doc.startDate).getTime() : 0;

    return {
        ...doc,
        clientLabel: `${doc?.client?.clientName ?? "—"}`,
        gameLabel,
        gameList,
        gameConfigs,
        amountLabel: (amount ?? "—") === "" ? "—" : amount,
        amountList,
        roundsLabel: (rounds ?? "—") === "" ? "—" : rounds,
        roundsList,
        currencyLabel: doc?.currency || "—",
        statusCode: Number(doc?.campaignStatus ?? 4),
        startTime: startMs,
        clientIdStr: doc?.client?.clientId != null ? String(doc.client.clientId) : "",
        playerList: Array.isArray(doc?.playerList) ? doc.playerList : [],
        bonusSeed: doc?.operatorReference || doc?.bonusCode || "",
        clientCodeStr: doc?.client?.clientCode ? String(doc.client.clientCode) : "",
    };
}
export function sortAndNumber(list, asc) {
    const sorted = [...list].sort((a, b) => asc ? (a.startTime - b.startTime) : (b.startTime - a.startTime));
    const n = sorted.length;
    return sorted.map((row, i) => ({ ...row, rowNumber: asc ? (i + 1) : (n - i) }));
}
export function mapRowToPlayersCampaign(row, { provider, bonusPrefix }) {
    const slot = row?.slotConfig || null;
    const slotCfgs = Array.isArray(row?.slotConfigs) ? row.slotConfigs : null;
    const games = slotCfgs
        ? slotCfgs.map(cfg => ({ gameId: cfg.game?.gameId, gameName: cfg.game?.gameName })).filter(g => g.gameId)
        : (Array.isArray(slot?.games) ? slot.games.map(({ gameId, gameName }) => ({ gameId, gameName })) : []);
    return {
        ...row,
        campaignId: row.campaignId || "",
        campaignName: row.campaignName || "",
        campaignType: row.campaignType || "",
        currency: row.currency || "",
        client: { clientId: row.clientIdStr || "", clientName: row.clientLabel || "", clientCode: row.clientCode || row.clientCodeStr || "" },
        provider,
        playerList: Array.isArray(row.playerList) ? row.playerList : [],
        bonusSeed: row.bonusSeed || "",
        bonusPrefix: bonusPrefix || "",
        startDate: row.startDate || null,
        endDate: row.endDate || null,
        slotConfig: slotCfgs ? {
            games: slotCfgs.map(cfg => ({ gameId: cfg.game?.gameId, gameName: cfg.game?.gameName })).filter(g => g.gameId),
            amountPerRound: slotCfgs[0]?.amountPerRound,
            rounds: slotCfgs[0]?.rounds
        } : (row?.slotConfig ? {
            games: Array.isArray(row.slotConfig.games)
                ? row.slotConfig.games.map(({ gameId, gameName }) => ({ gameId, gameName }))
                : [],
            amountPerRound: row.slotConfig.amountPerRound,
            rounds: row.slotConfig.rounds
        } : null),
        slotConfigs: slotCfgs || row?.slotConfigs || null,
        gameId: slotCfgs?.[0]?.game?.gameId ?? (Array.isArray(row?.slotConfig?.games) ? row.slotConfig.games[0]?.gameId : row?.gameId || ""),
        clientCode: row.clientCode || row.clientCodeStr || "",
        baseStatus: (row.baseStatus ?? row.campaignStatus ?? row.statusCode),
    };
}
export function toUnixSeconds(t) {
    if (t == null) return null;
    const d = (t instanceof Date) ? t : new Date(String(t));
    const ms = d.getTime();
    return Number.isFinite(ms) ? Math.floor(ms / 1000) : null;
}
export function toInt(n) {
    const x = Number(n);
    return Number.isFinite(x) ? Math.trunc(x) : 0;
}
export function toNum(n) {
    const x = Number(n);
    return Number.isFinite(x) ? x : 0;
}
export function cleanUndefined(obj) {
    return Object.fromEntries(
        Object.entries(obj).filter(([, v]) => v !== undefined && v !== null && v !== "")
    );
}

